import React from 'react'
import TermRow from './TermRow'
import DisplayRow from './DisplayRow'
import type { TermsGridProps } from './types'
import { isDisplayRow } from './types'

const TermsGrid = ({ deal, rows, viewOnly = false, isNegotiating = false, register, errors, hasChanges, formatChange }: TermsGridProps) => {
  const visibleRows = rows.filter(row => row.visible !== false)

  if (!deal.diff && !viewOnly) return null

  return (
    <div className="bg-white border overflow-hidden sm:rounded-md text-sm sm:text-base">
      <div className="p-4 sm:px-6">
        <div className="min-w-0 grid gap-y-2 sm:gap-y-6 grid-cols-1 sm:grid-cols-4">

          <div className="pt-2 not-empty-pb-6 text-base border-b border-gray-400 font-semibold">
            Deal terms
          </div>
          <div className="pt-2 not-empty-pb-6 sm:px-6 text-sm border-b border-gray-400  font-semibold hidden sm:inline">
            {!viewOnly && hasChanges && 'Previous offer'}
          </div>
          <div className="pt-2 not-empty-pb-6 sm:px-6 text-sm border-b border-gray-400  font-semibold hidden sm:inline">
            {!viewOnly && hasChanges && 'Changes'}
          </div>
          <div className="pt-2 not-empty-pb-6 text-sm border-b border-gray-400  font-semibold hidden sm:inline">
            {!viewOnly && hasChanges && (isNegotiating ? 'Proposed terms' : 'Current offer')}
          </div>

          {visibleRows.map((row, i) =>
            isDisplayRow(row) ? (
              <DisplayRow key={i} row={row} />
            ) : (
              <TermRow
                key={row.key}
                field={row}
                deal={deal}
                viewOnly={viewOnly}
                isNegotiating={isNegotiating || false}
                register={register}
                errors={errors}
                formatChange={formatChange}
              />
            )
          )}
        </div>
      </div>
    </div>
  )
}

export default TermsGrid
